module.exports = __webpack_public_path__ + "img/a68e887a129dc8cceb1352c8ed03f66.3b8cbc53.jpg";